<template>

    <div id="root">
        <div class="column pagestyle___3At3P" style="height: 100%;position: relative;padding-top: 185px;">
            <div class="row">
                <div style="width: 630px; margin-right: 9%;float: left"></div>
                <form class="ant-form ant-form-horizontal" style="width: 430px; background: rgb(255, 255, 255); border-radius: 20px; padding: 60px 40px; box-shadow: rgba(235, 235, 235, 0.54) 0px 6px 10px 1px;">
                    <div class="row" style="margin-bottom: 20px;">
                        <h2 style="font-size: 18px; color: rgb(21, 21, 21); margin: 0px; flex: 1 1 0%;">找回密码</h2>
                    </div>
                    <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control-wrapper">
                            <div class="ant-form-item-control">
                                <span class="ant-form-item-children">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <span class="ant-input-prefix">
                                            <i class="layui-icon layui-icon-layer">
                                            </i>
                                        </span>
                                        <input placeholder="请输入身份证号" type="text" v-model="idCard" class="ant-input" value="">
                                  </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control-wrapper">
                            <div class="ant-form-item-control">
                                <span class="ant-form-item-children">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <span class="ant-input-prefix">
                                            <i class="layui-icon layui-icon-email"></i>
                                        </span>
                                        <input placeholder="请输入qq邮箱,用于找回密码" type="text" id="email" v-model="email" class="ant-input" value="">
                                  </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <a type="button" @click="ImmediatelyFind" class="ant-btn login-form-button ant-btn-primary" style="width: 100%; height: 40px;
                            background: rgb(55, 151, 240);font-size: 17px;line-height: 40px;">
                        <span>立即找回</span>
                    </a>
                    <p style="color: red;font-size: 13px;">
                        <i class="layui-icon layui-icon-tips"></i>
                        找回密码：系统将向您的注册邮箱发送一封包含密码的邮件！
                    </p>
                    <div style="width: 50%; float: left;margin-top: 22px;" @click="LoginImmediately()">
                        <a class="loginPersonal" style="color: #49af4a;;">立即登录</a>
                    </div>
                    <div style="width: 50%; float: right;margin-top: 22px;" @click="registerAnAccount()">
                        <a class="registerPersonal" style="float:right;color: #49af4a;">注册账号</a>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>
<script>
	export default {
		name: 'app',
		components: {
		},
		data() {
			return {
                idCard: '',
                email:''
			}
		},
		created() {
		},
		mounted() {

		},
		methods: {
            ImmediatelyFind(){
                if (this.idCard === '') {
                    this.$message({
                        message: '请输入身份证号！',
                        type: 'warning'
                    });
                    return false;
                } else if (this.idCard.length < 18 === '') {
                    this.$message({
                        message: '请输入正确的身份证号格式！',
                        type: 'warning'
                    });
                    return false;
                }else if (this.email === '') {
                    this.$message({
                        message: '请输入邮箱！',
                        type: 'warning'
                    });
                    return false;
                }

                const loading = this.$loading({
                    lock: true,
                    text: '请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let _this = this;
                let parames = new URLSearchParams();
                parames.append('idCard', this.idCard);
                parames.append('email', this.email);
                this.$axios.post(this.serverUrl + '/retrievePassWord', parames).then(resp => {
                    loading.close();
                    if (resp.data.code === 1) {
                        
                        this.$message({
                            showClose: true,
                            message: '系统已向您的注册邮箱发送一封包含密码的邮件！',
                            type: 'success'
                        });
                        setTimeout(function(){
                            _this.$router.push({path:'/login'});
                        },1500)
                    } else if (resp.data.code === 3) {
                        this.$message({
                            showClose: true,
                            message: '邮箱错误，请输入正确的邮箱',
                            type: 'error'
                        });
                    }  else {
                        this.$refs.slideblock.reset();
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            LoginImmediately(){
                this.$router.push({path:'/login'})
            },
			registerAnAccount(){
                this.$router.push({path:'/personRegister'})
            }
		}
	}
</script>

<style scoped src="../../static/css/login.css"></style>




// WEBPACK FOOTER //
// src/components/retrievePassword.vue